//React
import React from "react";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myProfileAction from '../action/myProfileAction';
import * as settingAction from '../action/settingAction';

//Material-ui
import Grid from '@material-ui/core/Grid';
import Switch from '@material-ui/core/Switch';


//Part
import PartPageTitle from './PartPageTitle';

//Icon



class Comp extends React.Component {


  componentDidMount() {
    document.title = '停止 - パートナーズ';
  }

  _serviceStopChange(value) {
    this.props.settingStopEdit(value);
  }

  render() {

    return (
      <div style={{maxWidth:'600px', margin:'auto'}}>
        <PartPageTitle
          title={'サービスの停止'}
          onback={ '/setting/' }
          helpType={ 'category' }
          helpFilter={ 'post' }
        />

        <div>
          <div style={{padding:'10px'}}>
            <div style={{padding:'5px'}}>
              会員サービスの停止とは、他会員からプロフィールや写真、投稿、などすべて
              情報がすべて非公開になります。 <br />
              掲載したみんなの投稿、Q&Aの質問、回答も非公開になります。<br />
              会員検索、みんなの投稿、Q&Aや他会員のプロフィールも閲覧できなくなります。
            </div>
            {
              (this.props.my.profile.userdata_sex === 'men') && (
                <div style={{padding:'5px'}}>
                  また有料サービス期日が残っている場合、停止中も有料サービスは消化いたしますが、
                  有料サービスの期日内に再開された場合は有料サービスをご利用いただけます。
                </div>
              )
            }


            <Grid container  justify="center" alignItems="center" spacing={1} style={{padding:'10px'}}>
              <Grid
                item
                onClick={ () => this._serviceStopChange(1) }
                className='link'
                style={{fontSize:'1.2em', textDecoration:'underline'}}
              >
                停止
              </Grid>
              <Grid item>
                <Switch
                  onChange={ (event) => this._serviceStopChange(event.target.checked ? 0 : 1) }
                  checked={ (this.props.my.setting.serviceStop === 1) ? false : true }
                />
              </Grid>
              <Grid
                item
                onClick={ () => this._serviceStopChange(0) }
                className='link'
                style={{fontSize:'1.2em', textDecoration:'underline'}}
              >
                稼働中
              </Grid>
            </Grid>
          </div>

        </div>

      </div>
    )

  }
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myProfileAction,
    ...settingAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
